import React from 'react';

import style from './style.module.less';

/**
 * Returns tab header container component
 * Contains the title, description, and action button for a returns tab section
 * @typedef {object} ReturnsTabHeaderProps
 * @property {React.ReactNode} children - The content to be displayed inside the header
 * @param {ReturnsTabHeaderProps} props - Component props
 * @returns {React.ReactElement} The Returns tab header container
 */
export const ReturnsTabHeader = ({ children }) => <div className={style.returnsTabHeader}>{children}</div>;
